define('controllers/editdestination',['require'],function(require) {
    return function() {
        window.textBoxToDestImage = function (boxId, imgId, isSearch) {
            var box = $("#{0}".format(boxId)),
            img = $("#{0}".format(imgId));

            populateImage(box, img, isSearch);
            box.on("keyup blur", function () {
                populateImage(box, img, isSearch);
            });
        }

        window.populateImage = function (box, img, isSearch) {
            img.attr("src", ServerData.StaticContentUrl + "images/destinationimages/{0}{1}?v={2}".format(
                isSearch ? 'search/' : '',
                box.val().toLowerCase(),
                Math.floor((Math.random() * 100) + 1))
            );
        }

        window.setDestLatLon = function () {
            var geocoder = new google.maps.Geocoder(),
                address = NameBox.val(),
                infoMessage = $("#infoMessage");

            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var firstResult = results[0].geometry.location;
                    console.log(firstResult);
                    var index = 0;
                    for (var name in firstResult) {
                        if (index == 0) LatBox.val(firstResult[name]);
                        else if (index == 1) LonBox.val(firstResult[name]);
                        else break;
                        index++;
                    }
                    //infoMessage.show().html(createGoogleMapsLink(firstResult.Xa, firstResult.Ya, "Verify") + "that the found lat lon from the googler are correct.");
                } else {
                    infoMessage.show().html("Failed to find lat lon, searching for '{0}' on the googler...".format(address));
                }
            });
        }

        window.createGoogleMapsLink = function (lat, lon, text) {
            return "<a href='{0}' target='_blank' style='text-decoration:underline;font-weight:bold;'>Verify</a>".format(createGoogleMapsURL(lat, lon));
        }
        window.createGoogleMapsURL = function (lat, lon) {
            return "https://maps.google.com/maps?q={0},{1}&num=1&t=m&z=11&iwloc=A".format(lat, lon);
        }

        textBoxToDestImage("smallImage", "imgSmallImage", true);
        textBoxToDestImage("largeImage", "imgLargeImage");

        //when region name is input, go to google and fill in lat lon
        var NameBox = $("#Name"),
            LatBox = $("#lat"),
            LonBox = $("#lon");

        NameBox.on("change", function () {
            setDestLatLon();
        });

        $("#checkLatLon").on("click", function (e) {
            e.preventDefault();
            window.open(createGoogleMapsURL(LatBox.val(), LonBox.val()));
        });
    };
});

